import { HTMLAttributes, PropsWithChildren, memo } from 'react';
import './Card.css';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
    padding?: 'none' | 'sm' | 'md' | 'lg';
}

/**
 * Card Component
 * Compound component for flexible card layouts
 */
const CardRoot = memo<PropsWithChildren<CardProps>>(
    ({ children, padding = 'md', className = '', ...props }) => {
        return (
            <div className={`card card--padding-${padding} ${className}`} {...props}>
                {children}
            </div>
        );
    }
);

CardRoot.displayName = 'Card';

const CardHeader = memo<PropsWithChildren<HTMLAttributes<HTMLDivElement>>>(
    ({ children, className = '', ...props }) => {
        return (
            <div className={`card__header ${className}`} {...props}>
                {children}
            </div>
        );
    }
);

CardHeader.displayName = 'Card.Header';

const CardBody = memo<PropsWithChildren<HTMLAttributes<HTMLDivElement>>>(
    ({ children, className = '', ...props }) => {
        return (
            <div className={`card__body ${className}`} {...props}>
                {children}
            </div>
        );
    }
);

CardBody.displayName = 'Card.Body';

const CardFooter = memo<PropsWithChildren<HTMLAttributes<HTMLDivElement>>>(
    ({ children, className = '', ...props }) => {
        return (
            <div className={`card__footer ${className}`} {...props}>
                {children}
            </div>
        );
    }
);

CardFooter.displayName = 'Card.Footer';

export const Card = Object.assign(CardRoot, {
    Header: CardHeader,
    Body: CardBody,
    Footer: CardFooter,
});
